module.exports = __webpack_public_path__ + "static/img/7.a6aa8c9a.jpg";